@if (!!user) {
<mat-card class="class*=mat-elevation-z0">
    <mat-card-header>
      <img mat-card-avatar [src]="'https://firebasestorage.googleapis.com/v0/b/angular-pwa-cf61b.appspot.com/o/'+ user.uid +'.svg?alt=media'" />
      <mat-card-title>{{ user.displayname }}</mat-card-title>
      <mat-card-subtitle>{{ !!user.company ? user.company : 'freelance' }}</mat-card-subtitle>
    </mat-card-header>
    
</mat-card>
}
<mat-divider></mat-divider>
<mat-list>
    <!-- <mat-list-item (click)="navigate(['/', 'manage-account'])"><mat-icon>account_box</mat-icon>Manage account (NYI)</mat-list-item>
    <mat-list-item (click)="setDark()"><mat-icon>brightness_6</mat-icon>Dark mode (NYI)</mat-list-item> -->
    <mat-list-item (click)="navigate(['/', 'my-notifications'])"><mat-icon>notifications_active</mat-icon>My Notifications</mat-list-item>
    <mat-list-item (click)="navigate(['/', 'help'])"><mat-icon>help</mat-icon>Help</mat-list-item>
    <mat-list-item (click)="signOut()"><mat-icon>exit_to_app</mat-icon>Sign out</mat-list-item>
</mat-list>